import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { type CSSProperties, onMounted, ref, watch, computed } from 'vue'
import tippy, { type Instance, type Placement } from 'tippy.js'

import 'tippy.js/animations/scale.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'Popover',
  props: {
    value: { type: Boolean, default: false },
    trigger: { default: 'click' },
    placement: { default: 'bottom' },
    appendTo: {},
    contentStyle: {},
    center: { type: Boolean, default: false }
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const instance = ref<Instance>()
const triggerRef = ref<HTMLElement>()
const contentRef = ref<HTMLElement>()
const contentVisible = ref(false)

const contentStyle = computed(() => {
  return props.contentStyle || {}
})

watch(() => props.value, () => {
  if (!instance.value) return
  if (props.value) instance.value.show()
  else instance.value.hide()
})

onMounted(() => {
  instance.value = tippy(triggerRef.value!, {
    content: contentRef.value!,
    allowHTML: true,
    trigger: props.trigger,
    placement: props.placement,
    interactive: true,
    appendTo: props.appendTo || document.body,
    maxWidth: 'none',
    offset: [0, 8],
    duration: 200,
    animation: 'scale',
    theme: 'popover',
    onShow() {
      contentVisible.value = true
    },
    onShown() {
      if (!props.value) emit('update:value', true)
    },
    onHidden() {
      if (props.value) emit('update:value', false)
      contentVisible.value = false
    },
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["popover", { 'center': _ctx.center }]),
    ref_key: "triggerRef",
    ref: triggerRef
  }, [
    _createElementVNode("div", {
      class: "popover-content",
      style: _normalizeStyle(contentStyle.value),
      ref_key: "contentRef",
      ref: contentRef
    }, [
      (contentVisible.value)
        ? _renderSlot(_ctx.$slots, "content", { key: 0 })
        : _createCommentVNode("", true)
    ], 4),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})